import React, { useCallback, useEffect, useState } from 'react';
import tw, { styled } from 'twin.macro';

const Container = styled.h2`
  ${tw`font-sans text-base md:text-2xl leading-tight font-semibold text-center whitespace-pre-wrap`}
  ${props =>
    props.children.length < 50
      ? tw`text-lg md:text-xl`
      : tw`text-base md:text-2xl`}
  @media(max-width: 320px) {
    ${props => (props.children.length < 50 ? tw`text-base` : tw`text-sm`)}
  }
  overflow-wrap: break-word;
`;

// How long to wait in ms before displaying each character
const characterDuration = 15;

const SplitText = ({ children }) => {
  const [charIndex, setCharIndex] = useState(0);
  const [typingInterval, setTypingInterval] = useState(null);

  const incrementChar = useCallback(() => setCharIndex(index => index + 1), []);

  useEffect(() => {
    if (!typingInterval && charIndex < children.length) {
      setTypingInterval(setInterval(incrementChar, characterDuration));
    }

    return () => {
      if (charIndex === children.length) {
        clearInterval(typingInterval);
        setTypingInterval(null);
      }
    };
  }, [typingInterval, incrementChar, charIndex, children.length]);

  return (
    <Container aria-label={children}>{children.slice(0, charIndex)}</Container>
  );
};

export default SplitText;
